<div class="container" style="padding-top: 150px">
  <app-breadcrumb category="Shopping Bag / Address"></app-breadcrumb>

  <div class="row">
    <div class="col-lg-4 col-md-12 col-sm-12">
      <!-- <h5>Home/ Shopping Bag /Address</h5> -->
      <br />
      <br />
      <br />
      <h1 style="font-weight: bold">Product in Checkout Bag</h1>
      <a style="color: blue; font-size: 14px;" routerLink="/checkout">Edit Bag</a>
      <hr class="liness" />
      <app-addresspage-item
        *ngFor="let item of items"
        [data]="item"
      ></app-addresspage-item>
      <hr class="liness" />
      <div class="row">
        <h4 class="col-4">Subtotal</h4>
        <div class="col-5"></div>
        <h5 class="col-3">Rs.{{ sub_total }}</h5>
      </div>
      <hr class="new1" />
      <div class="row">
        <h4 class="col-4">Shipping</h4>
        <div class="col-5"></div>
        <h5 class="col-3">Rs.{{ deliver_fee }}</h5>
      </div>
      <hr class="new1" />
      <div class="row">
        <h4 class="col-4" style="font-weight: bolder">Total</h4>
        <div class="col-5"></div>
        <h5 class="col-3">Rs.{{ total }}</h5>
      </div>
    </div>
    <div class="col-lg-1"></div>
    <div class="col-lg-7">
      <div class="row" id="ship">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <h2 style="font-weight: bold">Shipping Address</h2>
          <input
            class="form-control-lg"
            id="email"
            type="text"
            placeholder="Email"
            [value]="address.email || ''"
            (input)="address.email = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="First Name"
            [value]="address.customer_name || ''"
            (input)="address.customer_name = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="Adress line 1"
            [value]="address.address || ''"
            (input)="address.address = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="Address line 2"
            [value]="address.address_2 || ''"
            (input)="address.address_2 = $event.target.value"
          />

          <input class="form-control-lg" type="text" placeholder="State" [value]="address.state || ''"
          (input)="address.state = $event.target.value"/>
        </div>
        <!-- <div class="col-lg-1">

                 </div> -->
        <div id="container-2" class="col-lg-6 col-md-12 col-sm-12">
          <input
            class="form-control-lg"
            type="text"
            placeholder="Phone no"
            [value]="address.phone || ''"
            (input)="address.phone = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="Last Name"
            [value]="address.last_name || ''"
            (input)="address.last_name = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="House No."
            [value]="address.door || ''"
            (input)="address.door = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="City"
            [value]="address.city || ''"
            (input)="address.city = $event.target.value"
          />

          <input
            class="form-control-lg"
            type="text"
            placeholder="Pincode No."
            [value]="address.pincode || ''"
            (input)="address.pincode = $event.target.value"
          />
        </div>
      </div>
      <div class="row" id="shipping">
        <div class="col-lg-5 col-md-12 col-sm-12">
          <h2 style="font-weight: bolder;">Shipping Method</h2>
          <hr class="liness" />
          <div class="row">
            <mat-radio-button [checked]="true"   value="1" style=" font-size: 15px; font-family: 'proxima-nova';">Standard Shipping</mat-radio-button>
        
            <h5 style=" font-size: 15px; font-family: 'proxima-nova';" class="col-2">Rs.{{deliver_fee}}</h5>
          </div>
          <hr class="liness" />
          <div>
            <p style="font-size: 12px">
              &#10003; Order before 18:00 to received bettween 1 to 3 Working
              days
            </p>
            <p style="font-size: 12px">
              &#10003; Pay With Google pay,paytm, Mstercard, Visa, Paypal
            </p>
            <p style="font-size: 12px">&#10003; Shipping Only in india</p>
            <p style="font-size: 12px">
              &#10003; Order can be returned within 7 Days.
            </p>
          </div>
        </div>
        <div class="col-1"></div>
        
        <div class="col-lg-5 col-md-12 col-sm-12">
          <h2 style="font-weight: bolder;">Payment Method</h2>
          <hr class="liness" />
          <mat-radio-group aria-label="Select an option" (change)="pay($event)">
            <div class="col-lg-5 col-md-12 col-sm-12" style="padding-left: 0px; padding-right: 0px;">
              <mat-radio-button value="Prepaid" style="width: 100%; font-size: 15px; font-family: 'proxima-nova';">Pay Now</mat-radio-button>
              <hr class="liness" style="width: 220px; height: 1px;"/>
              <mat-radio-button  value="COD" style="width: 100%; font-size: 15px; font-family: 'proxima-nova';">Pay On Delivery</mat-radio-button>
            </div>
          </mat-radio-group>
          <hr class="liness" />
          <div class="row">
            <h3 class="col-6" style="font-weight: bold; color: gray;">Grand Total</h3>
            <div class="col-1"></div>
            <h3 style="font-weight: bolder;" class="col-2">Rs.{{total}}</h3>
          </div>
          <hr class="liness" />
          <div class="row" style="align-content: center">
            <input
              type="checkbox"
              style="border-radius: 50%; font-weight: bold"
              class="col-1"
            />
            <h5 class="col-11">
              I accept the
              <a style="font-weight: bold">Terms & Conditions</a> and Privacy
              Statement
            </h5>
            <br />
            <button
              (click)="deploy()"
              class="btn btn-dark"
              style="
                padding: 12px;
                margin: 12px;
                font-weight: bold;
                border-radius: 0px;
                background-color: black;
                font-size: 14px;
              "
            >
              Confrim Your Order
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
